import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavBar from './Componets/NavBar';
import Home from './Screens/Home';
import Services from './Screens/Services';
import Contact from './Screens/Contact';
import HowWeWork from './Screens/HowWeWork';
import Know from './Screens/Know'

function App() {
  return (
    <Router>
      <div className="App">
        <head>
          <title>QS Logistics</title>
        </head>

        <NavBar/>
        
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/how-we-work" element={<HowWeWork />} />
          <Route path="/Know" element={<Know />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;